var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 35"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 4.3,
    rx: 4.2,
    ry: 4.3,
    fill: "#feebc1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.8,
    cy: 11.05,
    rx: 4.2,
    ry: 4.3,
    fill: "#fdbb31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.2,
    cy: 11.05,
    rx: 4.2,
    ry: 4.3,
    fill: "#26b382"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 30.7,
    rx: 4.2,
    ry: 4.3,
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.2,
    cy: 23.95,
    rx: 4.2,
    ry: 4.3,
    fill: "#a5e1d2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.8,
    cy: 23.95,
    rx: 4.2,
    ry: 4.3,
    fill: "#ff5400"
  })))));
}

export default SvgCustomDnbLoading;